import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { shortenPath } from '../../../../utils/utils';

function NRShortenedPathTooltip({ filePath, containerRef, contentClass, textClass, customMinWidth, maxWidth, textStyle }) {
  return (
    <Tooltip enterTouchDelay={1500} followCursor={true} title={filePath?.length > 1 ? filePath : ''} placement={'top-start'}>
      <Box ref={containerRef} className={contentClass} sx={{ cursor: 'default' }}>
        <span {...(customMinWidth && { style: { minWidth: `${customMinWidth}px` } })} className={textClass} style={textStyle}>
          {shortenPath(filePath, maxWidth)}
        </span>
      </Box>
    </Tooltip>
  );
}

export default NRShortenedPathTooltip;
